var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8267 0.353851H2.50328C1.67376 0.353851 1.00415 1.02346 1.00415 1.85298V8.86893C1.00415 9.69845 1.67376 10.3681 2.50328 10.3681H3.41276V13.956L6.90074 10.3681H13.8267C14.6563 10.3681 15.3259 9.69845 15.3259 8.86893V1.85298C15.3259 1.02346 14.6563 0.353851 13.8267 0.353851Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41272 3.54201H12.9172",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41272 5.51087H12.9172",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41272 7.47973H11.3981",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.16c6cfa405b8a20aa73af09d41048630.svg";
export { ForwardRef as ReactComponent };